import { Component, Input, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";
import { BasicActionsEventType } from "./basic-actions-event-type";

@Component({
  selector: "app-user-actions",
  templateUrl: "./user-actions.component.html",
})
export class UserActionsComponent implements OnInit {
  constructor() {}

  @Output()
  emitter = new Subject<BasicActionsEventType>();

  @Input()
  data = {};

  ngOnInit(): void {}

  onAction1(event) {
    event.stopPropagation()
    this.emitter.next({
      cmd: "edit",
      data: this.data,
    });
  }
  onAction2(event) {
    event.stopPropagation()
    this.emitter.next({
      cmd: "delete",
      data: this.data,
    });
  }

  onAction3(event) {
    event.stopPropagation()
    this.emitter.next({
      cmd: "view",
      data: this.data,
    });
  }

  onAction4(event) {
    event.stopPropagation()
    this.emitter.next({
      cmd: "login",
      data: this.data,
    });
  }

  onAction5(event) {
    event.stopPropagation()
    this.emitter.next({
      cmd: "edit_manual",
      data: this.data,
    });
  }

  ngOnDestroy() {
    this.emitter.unsubscribe();
  }
}